'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Locked.tsx
var SvgLocked = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.25 7.556C6.25 4.149 8.752 1.25 12 1.25s5.75 2.9 5.75 6.306v1.589c.35.065.675.17.982.343a3.937 3.937 0 0 1 1.623 1.797c.216.473.308.985.352 1.582.043.583.043 1.306.043 2.215v1.615c0 .908 0 1.63-.043 2.214-.044.596-.136 1.109-.352 1.582a3.937 3.937 0 0 1-1.623 1.796c-.451.256-.94.362-1.494.412-.534.049-1.193.049-2.003.049h-6.47c-.81 0-1.469 0-2.003-.049-.554-.05-1.043-.156-1.493-.412a3.937 3.937 0 0 1-1.624-1.796c-.216-.473-.308-.986-.352-1.582-.043-.583-.043-1.306-.043-2.215v-1.615c0-.908 0-1.63.043-2.214.044-.597.136-1.11.352-1.582A3.936 3.936 0 0 1 5.27 9.488c.306-.173.63-.278.981-.343v-1.59Zm1.5 1.476c.309-.004.646-.004 1.015-.004h6.47c.369 0 .706 0 1.015.004V7.556c0-2.73-1.975-4.806-4.25-4.806S7.75 4.825 7.75 7.556v1.476Zm-.853 1.538c-.447.04-.699.116-.89.224a2.437 2.437 0 0 0-.998 1.116c-.11.24-.182.551-.22 1.067-.039.522-.039 1.19-.039 2.134v1.556c0 .944 0 1.612.039 2.134.038.515.11.826.22 1.066.226.494.58.88.999 1.117.19.108.442.183.89.224.458.041 1.048.042 1.902.042h6.4c.854 0 1.444 0 1.903-.042.447-.04.698-.116.89-.224.418-.237.772-.623.998-1.117.11-.24.182-.55.22-1.066.039-.522.039-1.19.039-2.134V15.11c0-.945 0-1.612-.039-2.134-.038-.516-.11-.826-.22-1.067a2.437 2.437 0 0 0-.998-1.116c-.191-.108-.443-.183-.89-.224-.459-.042-1.05-.042-1.903-.042H8.8c-.854 0-1.444 0-1.903.042Zm6.072 6.18a2 2 0 1 0-1.938 0c-.02.08-.031.164-.031.25v1a1 1 0 1 0 2 0v-1c0-.086-.01-.17-.031-.25Z" }));
var Locked_default = SvgLocked;

module.exports = Locked_default;
